import "intersection-observer";
import "shared/utils/i18n";
import React, { lazy, Suspense } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import { createRoot } from "react-dom/client";
import ErrorMonitoring from "shared/components/ErrorMonitoring";
import LoadingFullScreen from "shared/components/LoadingFullScreen";
import { ApolloProvider } from "@apollo/client";
import { client } from "shared/utils/apollo";
import { isPartner, isDocument, isWhitelabelAdmin } from "shared/utils/env";
import { BrowserRouter as Router } from "react-router-dom";

const AdminApp = lazy(() => import("./admin"));
const PartnerApp = lazy(() => import("./partner"));
const Document = lazy(() => import("./document"));
const WhitelabelAdminApp = lazy(() => import("./whitelabelAdmin"));

const App = isDocument
  ? Document
  : isWhitelabelAdmin
  ? WhitelabelAdminApp
  : isPartner
  ? PartnerApp
  : AdminApp;
const basename = isWhitelabelAdmin
  ? "/whitelabel"
  : isPartner
  ? "/partner"
  : "/";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <ErrorMonitoring>
    <StyledEngineProvider injectFirst>
      <ApolloProvider client={client}>
        <Router basename={basename}>
          <Suspense fallback={<LoadingFullScreen />}>
            <App />
          </Suspense>
        </Router>
      </ApolloProvider>
    </StyledEngineProvider>
  </ErrorMonitoring>
);
